<template lang="html">
  <div class="col-lg-9 col-page-content page-style-1">

    <div class="row mt-0 box-candidates">

      <!-- Últimos perfiles guardados -->
      <div class="col-12 mt-0 col-candidates-list">
        <div class="row">

          <div class="col-12 mt-0 box-acc-title-s1">
            <h4>Perfiles Guardados</h4>
            <hr />
          </div>

          <div class="col-12 mt-3 mb-2 col-sm box-acc-title-s2">
            <h4>Candidatos recientes</h4>
          </div>

          <div class="col-12 col-candidate-s2 variant-2 mb-3" v-for="(postulate, cand1Inx) in postulates" :key="'cand1Inx-'+cand1Inx">
            <div class="box">
              <a class="btn-del" @click="deleteFavorite(postulate.id)">x</a>

              <div class="col-vac-info">
                <div>
                  <span>Vacante aplicada: {{postulate.vacant}}</span>
                </div>
              </div>

              <div class="col col-photo">
                <div class="img" v-bind:style="{ backgroundImage: 'url('+postulate.imageUrl+')' }"></div>
              </div>

              <div class="col col-info">
                <h4 class="name"><a target="_blank" :href="'https://jobusco.com/#/perfil-candidato/'+$root._converToURL(postulate.name, postulate.usuarios_id)">{{postulate.name}}</a></h4>
                <h5>
                  <!-- <span class="career">Agente de seguros</span><br /> -->
                  <i class="loc-icon"></i><span class="location">{{postulate.town}}, {{postulate.state}}.</span>
                </h5>
              </div>

              <div class="col-12 col-line">
                <hr />
              </div>

              <div class="col col-2ndbuttons lg">
                <a :href="'mailto:'+postulate.email" class="btn-msg" >
                  <img src="public/images/pages/account/icon-messages-active.png">
                  <span>Enviar mensaje</span>
                </a>

               <a class="btn-profile"  target="_blank" :href="'https://jobusco.com/#/perfil-candidato/'+$root._converToURL(postulate.name, postulate.usuarios_id)">
                  <i class="far fa-eye icon"></i>
                  <span>Ver Perfil</span>
                </a>

                <a class="btn-profile linkedin" :href="postulate.linkedin" target="_blank">
                  <img src="public/images/pages/account/linkedin.png">
                  <span>Visitar Perfil</span>
                </a>
              </div>

              <div class="col col-buttons">
                <a class="trans-250 btn-squ-cur-1 outline-aqua-text btn-HelvNeu" @click="downloadcv(postulate.usuarios_id)">Descargar CV <i class="fas fa-caret-down"></i></a>
              </div>
            </div>
          </div>

          <!-- <div class="col-12">
            <div class="row pagination-container">
              <div class="col-12 col-pagination">
                <b-pagination
                  v-model="pagination.current_page"
                  :total-rows="pagination.total"
                  :per-page="pagination.per_page"
                  aria-controls="my-table"
                ></b-pagination>
              </div>
            </div>
          </div> -->

        </div>
      </div>
      <!--  -->

    </div>
    <sweet-modal ref="modalLoading" hide-close-button blocking>

      <img src="/public/images/shared/loading.gif" width="30%">
        <p style="text-align: center;"><b>Cargando...</b></p>
    </sweet-modal>
    <sweet-modal ref="modalAlert" :icon="modal.icon">
          <p>{{modal.msg}}</p>
           <br><br>
          <a class="btn btn-info" @click="$refs.modalAlert.close()">Aceptar</a>
    </sweet-modal>


  </div>
</template>

<script>
export default {
  data(){
    return{
      pagination:{
        current_page:1,
        order:0,
        per_page:10,
      },
      postulates:[],
      modal:{
          icon:null,
          msg:null
      },
    }
  },
  methods: {

      getData(){
        axios.get(tools.url("/api/admin/getFavoritePostulateFront"))
        .then((response)=>{
              this.postulates = response.data;

          }).catch((error)=>{
              this.modal.icon = 'error';
              this.modal.msg = 'Ocurrio un error al obtener la información';
              this.$refs.modalAlert.open();
          });
      },
      deleteFavorite(id){
        this.$refs.modalLoading.open();
        axios.delete(tools.url("/api/admin/deleteFavoritePostulate/"+id))
        .then((response)=>{
              this.$refs.modalLoading.close();
              this.modal.icon = 'success';
              this.modal.msg = 'Cantidato eliminado de favoritos';
              this.$refs.modalAlert.open();
              this.getData();

          }).catch((error)=>{
              this.$refs.modalLoading.close();
              this.modal.icon = 'error';
              this.modal.msg = 'Ocurrio un error al obtener la información';
              this.$refs.modalAlert.open();
          });

          
      },
      downloadcv(id){
          axios.get(tools.url("/downloadCvPostulate/"+id)).then((response)=>{
              console.log(response);
              window.open(response.data,'_blank');
          }).catch(()=>{});
      }



  },
  mounted(){
      this.getData();
  },
}
</script>
